import HeroBasic from '../components/HeroBasic'
import Card from '../components/Card'
import List from '../components/List'
import InfoBox from '../components/InfoBox'

function BuildInfoGrid() {
    var infoList = [
        {
            header: "Document Types",
            items: [
                "INSP - Inspection Reports",
                "NOV - Notices of Violation (Informal Actions)",
                "ENF - Enforcement Actions",
                "INFOREQ - Information Collection Requests"
            ]
        },
        {
            header: "Statutes",
            items: [
                "CAA – Clean Air Act",
                "CWA – Clean Water Act",
                "RCRA – Resource Conservation and Recovery Act",
                "Other statutes are available for search but may not be fully included due toPEER’s narrowing of the original FOIA request"
            ]
        },
        {
            header: "Region",
            items: [
                "1-10", "HQ"
            ]
        },
        {
            header: "Companies and Entities",
            items: [
                "The indexed organizational names from each document."
            ]
        }
    ] 

    var infoCards = infoList.map((a, index) => 
        <InfoBox key={index} header={a.header}>
            <List items={a.items} />
        </InfoBox>
    )

    return <div className="grid" style={{gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))"}}>{infoCards}</div>
}

function PortalInfo() {
    var heroTitle = "Search Information"
    var heroSubtitle = "Search help and portal documentation."

    var cardHeader = "Available Search Features"
    var infoGrid = BuildInfoGrid()
    return (
        <div>
            <HeroBasic title={heroTitle} subtitle={heroSubtitle} />
            <Card header={cardHeader}>
                {infoGrid}
                <p></p>
                <h3 className="mt-4">Search Help</h3>
                <ul>
                    <li>When keyword searching on the Portal page, you are searching on the shortened indexed information.</li>
                    <li>For a complete keyword search, the website provides an advanced feature that searches into the documents rather than the document summaries. Click Advanced Search for a full keyword search across all documents. Note that some documents that were provided as picture files may not allow proper keyword searching.</li>
                </ul>
            </Card>
        </div>
    )
}

export default PortalInfo